// extracted by mini-css-extract-plugin
export default {"footer_content":"Footer_footer_content__jAK3C","footer":"Footer_footer__H7e0a","footer_links":"Footer_footer_links__KS4Za","active":"Footer_active__9dDB-"};